import { useFormikContext } from "formik";

interface KmMottorsProps {
  disabled?: boolean;
}

export default function KmMottors({ disabled = false }: KmMottorsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { values, setFieldValue } = useFormikContext<any>();

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="odometerVehicle" className="font-semibold">
        Digite o valor do Hodômetro
      </label>
      <input
        id="odometerVehicle"
        name="odometerVehicle"
        type="number"
        value={values.odometerVehicle}
        onChange={(e) => setFieldValue("odometerVehicle", e.target.value)}
        className="border rounded px-3 py-2 text-black disabled:bg-gray-100 disabled:cursor-not-allowed"
        placeholder="Digite o hodômetro da moto"
        disabled={disabled}
      />
    </div>
  );
}
